export const ticketAiStatus = ticket => {
  if (ticket?.aiServiceStatus === "automation") {
    return {
      label: `IA · ${ticket.activePrompt?.name || "Agente de IA"}`,
      color: "#1d4ed8",
      background: "#dbeafe",
      source:
        ticket.aiSelectionSource === "queue"
          ? "Fila"
          : ticket.aiSelectionSource === "flow"
            ? "Fluxo"
            : "Conexão"
    };
  }
  if (ticket?.aiServiceStatus === "waiting_human") {
    return {
      label: "Aguardando atendente",
      color: "#92400e",
      background: "#fef3c7",
      source: null
    };
  }
  return {
    label: ticket?.user?.name
      ? `Atendimento humano · ${ticket.user.name}`
      : "Atendimento humano",
    color: "#334155",
    background: "#e2e8f0",
    source: null
  };
};

export const canControlTicketAi = (ticket, user) => {
  if (!ticket?.id || !["open", "pending"].includes(ticket.status)) return false;
  if (user?.profile === "admin" || user?.super) return true;
  if (["enable", "enabled"].includes(user?.allTicket)) return true;
  if (Number(ticket.userId) === Number(user?.id) && ticket.userId) return true;
  if (ticket.userId) return false;
  return Boolean(
    ticket.queueId &&
      user?.queues?.some(queue => Number(queue.id) === Number(ticket.queueId))
  );
};

export const resumeTargets = (ticket, queues) => {
  const targets = [];
  if (
    ticket?.whatsapp?.initialAutomationStrategy === "agent" &&
    ticket.whatsapp.promptId
  ) {
    targets.push({
      value: "connection",
      label: `Agente de entrada · ${ticket.whatsapp.prompt?.name || "Agente da conexão"}`,
      queueId: null
    });
  }
  (queues || [])
    .filter(queue => queue.promptId)
    .forEach(queue => {
      targets.push({
        value: String(queue.id),
        label: `${queue.name} · ${queue.agentPrompt?.name || "Agente de IA"}`,
        queueId: queue.id
      });
    });
  return targets;
};

export const preferLatestTicketAiState = (current, incoming) => {
  if (!current || Number(current.id) !== Number(incoming?.id)) return incoming;
  const currentVersion = Number(current.aiServiceVersion);
  const incomingVersion = Number(incoming.aiServiceVersion);
  if (
    Number.isFinite(currentVersion) &&
    Number.isFinite(incomingVersion) &&
    incomingVersion < currentVersion
  ) {
    return current;
  }
  return incoming;
};
